import React from 'react';

import MetricBox from './MetricBox';

interface WindDirectionIndicatorProps {
  degrees: number;
}

const WindDirectionIndicator: React.FC<WindDirectionIndicatorProps> = ({ degrees }) => {
  return <MetricBox label='Wind Dir' value={`${Math.round(degrees)}°`} />;
};

export default WindDirectionIndicator;
